/* eslint-disable eqeqeq */
import React from 'react';
import RangeFilter from './CoreComponents/RangeFilter';

const PrizeMoneyRangeFilter = (props) => {
    const { filterInputs, searchTypes, handlePrizeMoneyChange, 'data-testid': dataTestId } = props;
    const { prizeMoneyValues } = searchTypes;
    const prizeMoneyDict = {};
    prizeMoneyValues.forEach(pm => {
        prizeMoneyDict[pm.id] = pm.label;
    });
    let { prizeMoneyMin, prizeMoneyMax } = filterInputs;
    prizeMoneyMin = prizeMoneyMin || 1;
    prizeMoneyMax = prizeMoneyMax || prizeMoneyValues.length;

    const prizeMoneyDisplay = (min, max) => {
        if (min == 1 && max == prizeMoneyValues.length) {
            return 'All';
        }
        if (min == 1) {
            return `${prizeMoneyDict[max]} and Under`;
        }
        if (max == prizeMoneyValues.length) {
            return `${prizeMoneyDict[min]} and Over`;
        }
        return `${prizeMoneyDict[min]} to ${prizeMoneyDict[max]}`;
    };

    console.log('PrizeMoneyRangeFilter', props, prizeMoneyMin, prizeMoneyMax);
    return (
        <React.Fragment>
            <RangeFilter
                onChange={handlePrizeMoneyChange}
                rangeKeyMin={1}
                rangeKeyMax={prizeMoneyValues.length}
                defaultValueArr={[prizeMoneyMin, prizeMoneyMax]}
                min={prizeMoneyMin}
                max={prizeMoneyMax}
                title={'Prize Money'}
                customRangeDisplay={prizeMoneyDisplay}
                data-testid={dataTestId}
            />
        </React.Fragment>
    );
};

export default PrizeMoneyRangeFilter;
